import { getBusinessObjectives } from 'pricing-pages-lib/api/BusinessObjectiveApi';
import makeFetchRequest from './helpers/makeFetchRequest';
import { createRequestActions, createRequestTypes } from './helpers/RequestActions';
import { BUSINESS_OBJECTIVES } from './constants/RequestedDataTypes';
export const FetchBusinessObjectivesRequestTypes = createRequestTypes(BUSINESS_OBJECTIVES);
export const FetchBusinessObjectivesActions = createRequestActions(FetchBusinessObjectivesRequestTypes);
export const fetchBusinessObjectives = ({
  highlightedProducts,
  productLine
}) => {
  return makeFetchRequest({
    requestActions: FetchBusinessObjectivesActions,
    fetch: getBusinessObjectives,
    payload: {
      highlightedProducts,
      productLine
    }
  });
};